import { CreateElement } from 'vue'

import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Element, AlignableElement } from '@src/mixins/element/element'
import { Alignable } from '@src/mixins/alignable/alignable'
import { Icon } from '@src/elements/icon/icon'

import { Annotate } from '@src/decorators/annotate'

import './button.sass'

@Component
@Annotate('A simple button.')
export class Button extends Mixins<AlignableElement>(Element, Alignable) {

  @Prop({ required: false, default: 'default' })
  type: 'default' | 'remove' | 'outline' | 'elevated' | 'square-outline-blue' | 'square-outline-red'

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.alignableStyles,
      ...this.buttonStyles
    ]

    return (
      this.renderElement(h, styleClasses, this.disabled, [
        this.renderIcon(h),
        this.renderLabel(h)
      ])
    )
  }

  protected get buttonStyles () {
    let styleClasses = ['button', this.type]
    return styleClasses
  }

}

@Component
@Annotate('A menu button.')
export class MenuButton extends Mixins<AlignableElement>(Element, Alignable) {

  private opened = false
  private key = Math.random().toString(36).substring(2,7)

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.alignableStyles,
      ...this.menuButtonStyles
    ]

    return (
      this.renderElement(h, styleClasses, this.key, [
        this.renderIcon(h),
        this.renderLabel(h),

        this.renderMenu(h)
      ], () => {
        this.opened = !this.opened
        this.toggleKeyboardEvents(this.opened),
        this.toggleOutsideClickEvent(this.opened)
      })
    )
  }

  protected renderMenu (h: CreateElement) {
    return (this.opened) ? this.$slots.default : null
  }

  protected renderIcon (h: CreateElement) {
    return this.$slots.button ? this.$slots.button :
      <div class='left-icon'>
        <Icon name={this.icon || 'util/menu'} />
      </div>

  }

  protected get menuButtonStyles () {
    return ['menu-button']
  }

  protected onEscape () {
    this.closeMenu()
  }

  protected onClickOutside () {
    this.closeMenu()
  }

  private closeMenu () {
    this.opened = false
  }

}
